import React from "react";
import ComicBase from "../../ComicBase";

export default function ComicNaruto() {
  return (
    <ComicBase
      titulo="La Viuda De Mi Vecina Capítulo 3 – Rose Blue 3D"
      portada="https://reycomix.com/wp-content/uploads/2023/04/My-Neighbors-Widow-3-RoseBlue3D-01.jpg"
paginas={[
  "https://reycomix.com/wp-content/uploads/2023/04/My-Neighbors-Widow-3-RoseBlue3D-01.jpg",
  "https://reycomix.com/wp-content/uploads/2023/04/My-Neighbors-Widow-3-RoseBlue3D-02.jpg",
  "https://reycomix.com/wp-content/uploads/2023/04/My-Neighbors-Widow-3-RoseBlue3D-03.jpg",
  "https://reycomix.com/wp-content/uploads/2023/04/My-Neighbors-Widow-3-RoseBlue3D-04.jpg",
  "https://reycomix.com/wp-content/uploads/2023/04/My-Neighbors-Widow-3-RoseBlue3D-05.jpg",
  "https://reycomix.com/wp-content/uploads/2023/04/My-Neighbors-Widow-3-RoseBlue3D-06.jpg",
  "https://reycomix.com/wp-content/uploads/2023/04/My-Neighbors-Widow-3-RoseBlue3D-07.jpg",
  "https://reycomix.com/wp-content/uploads/2023/04/My-Neighbors-Widow-3-RoseBlue3D-08.jpg",
  "https://reycomix.com/wp-content/uploads/2023/04/My-Neighbors-Widow-3-RoseBlue3D-09.jpg",
  "https://reycomix.com/wp-content/uploads/2023/04/My-Neighbors-Widow-3-RoseBlue3D-10.jpg",
  "https://reycomix.com/wp-content/uploads/2023/04/My-Neighbors-Widow-3-RoseBlue3D-11.jpg",
  "https://reycomix.com/wp-content/uploads/2023/04/My-Neighbors-Widow-3-RoseBlue3D-12.jpg",
  "https://reycomix.com/wp-content/uploads/2023/04/My-Neighbors-Widow-3-RoseBlue3D-13.jpg",
  "https://reycomix.com/wp-content/uploads/2023/04/My-Neighbors-Widow-3-RoseBlue3D-14.jpg",
  "https://reycomix.com/wp-content/uploads/2023/04/My-Neighbors-Widow-3-RoseBlue3D-15.jpg",
  "https://reycomix.com/wp-content/uploads/2023/04/My-Neighbors-Widow-3-RoseBlue3D-16.jpg",
  "https://reycomix.com/wp-content/uploads/2023/04/My-Neighbors-Widow-3-RoseBlue3D-17.jpg",
  "https://reycomix.com/wp-content/uploads/2023/04/My-Neighbors-Widow-3-RoseBlue3D-18.jpg",
  "https://reycomix.com/wp-content/uploads/2023/04/My-Neighbors-Widow-3-RoseBlue3D-19.jpg",
  "https://reycomix.com/wp-content/uploads/2023/04/My-Neighbors-Widow-3-RoseBlue3D-20.jpg",
  "https://reycomix.com/wp-content/uploads/2023/04/My-Neighbors-Widow-3-RoseBlue3D-21.jpg",
  "https://reycomix.com/wp-content/uploads/2023/04/My-Neighbors-Widow-3-RoseBlue3D-22.jpg",
  "https://reycomix.com/wp-content/uploads/2023/04/My-Neighbors-Widow-3-RoseBlue3D-23.jpg",
  "https://reycomix.com/wp-content/uploads/2023/04/My-Neighbors-Widow-3-RoseBlue3D-24.jpg",
  "https://reycomix.com/wp-content/uploads/2023/04/My-Neighbors-Widow-3-RoseBlue3D-25.jpg",
  "https://reycomix.com/wp-content/uploads/2023/04/My-Neighbors-Widow-3-RoseBlue3D-26.jpg",
  "https://reycomix.com/wp-content/uploads/2023/04/My-Neighbors-Widow-3-RoseBlue3D-27.jpg",
  "https://reycomix.com/wp-content/uploads/2023/04/My-Neighbors-Widow-3-RoseBlue3D-28.jpg",
  "https://reycomix.com/wp-content/uploads/2023/04/My-Neighbors-Widow-3-RoseBlue3D-29.jpg",
  "https://reycomix.com/wp-content/uploads/2023/04/My-Neighbors-Widow-3-RoseBlue3D-30.jpg",
  "https://reycomix.com/wp-content/uploads/2023/04/My-Neighbors-Widow-3-RoseBlue3D-31.jpg",
  "https://reycomix.com/wp-content/uploads/2023/04/My-Neighbors-Widow-3-RoseBlue3D-32.jpg",
  "https://reycomix.com/wp-content/uploads/2023/04/My-Neighbors-Widow-3-RoseBlue3D-33.jpg",
  "https://reycomix.com/wp-content/uploads/2023/04/My-Neighbors-Widow-3-RoseBlue3D-34.jpg",
  "https://reycomix.com/wp-content/uploads/2023/04/My-Neighbors-Widow-3-RoseBlue3D-35.jpg",
  "https://reycomix.com/wp-content/uploads/2023/04/My-Neighbors-Widow-3-RoseBlue3D-36.jpg",
  "https://reycomix.com/wp-content/uploads/2023/04/My-Neighbors-Widow-3-RoseBlue3D-37.jpg",
  "https://reycomix.com/wp-content/uploads/2023/04/My-Neighbors-Widow-3-RoseBlue3D-38.jpg",
  "https://reycomix.com/wp-content/uploads/2023/04/My-Neighbors-Widow-3-RoseBlue3D-39.jpg",
  "https://reycomix.com/wp-content/uploads/2023/04/My-Neighbors-Widow-3-RoseBlue3D-40.jpg",
  "https://reycomix.com/wp-content/uploads/2023/04/My-Neighbors-Widow-3-RoseBlue3D-41.jpg",
  "https://reycomix.com/wp-content/uploads/2023/04/My-Neighbors-Widow-3-RoseBlue3D-42.jpg",
  "https://reycomix.com/wp-content/uploads/2023/04/My-Neighbors-Widow-3-RoseBlue3D-43.jpg",
  "https://reycomix.com/wp-content/uploads/2023/04/My-Neighbors-Widow-3-RoseBlue3D-44.jpg",
  "https://reycomix.com/wp-content/uploads/2023/04/My-Neighbors-Widow-3-RoseBlue3D-45.jpg",
  "https://reycomix.com/wp-content/uploads/2023/04/My-Neighbors-Widow-3-RoseBlue3D-46.jpg",
  "https://reycomix.com/wp-content/uploads/2023/04/My-Neighbors-Widow-3-RoseBlue3D-47.jpg",
  "https://reycomix.com/wp-content/uploads/2023/04/My-Neighbors-Widow-3-RoseBlue3D-48.jpg",
  "https://reycomix.com/wp-content/uploads/2023/04/My-Neighbors-Widow-3-RoseBlue3D-49.jpg",
  "https://reycomix.com/wp-content/uploads/2023/04/My-Neighbors-Widow-3-RoseBlue3D-50.jpg",
  "https://reycomix.com/wp-content/uploads/2023/04/My-Neighbors-Widow-3-RoseBlue3D-51.jpg",
  "https://reycomix.com/wp-content/uploads/2023/04/My-Neighbors-Widow-3-RoseBlue3D-52.jpg",
  "https://reycomix.com/wp-content/uploads/2023/04/My-Neighbors-Widow-3-RoseBlue3D-53.jpg",
  "https://reycomix.com/wp-content/uploads/2023/04/My-Neighbors-Widow-3-RoseBlue3D-54.jpg",
  "https://reycomix.com/wp-content/uploads/2023/04/My-Neighbors-Widow-3-RoseBlue3D-55.jpg",
  "https://reycomix.com/wp-content/uploads/2023/04/My-Neighbors-Widow-3-RoseBlue3D-56.jpg",
  "https://reycomix.com/wp-content/uploads/2023/04/My-Neighbors-Widow-3-RoseBlue3D-57.jpg",
  "https://reycomix.com/wp-content/uploads/2023/04/My-Neighbors-Widow-3-RoseBlue3D-58.jpg",
  "https://reycomix.com/wp-content/uploads/2023/04/My-Neighbors-Widow-3-RoseBlue3D-59.jpg",
  "https://reycomix.com/wp-content/uploads/2023/04/My-Neighbors-Widow-3-RoseBlue3D-60.jpg",
  "https://reycomix.com/wp-content/uploads/2023/04/My-Neighbors-Widow-3-RoseBlue3D-61.jpg",
  "https://reycomix.com/wp-content/uploads/2023/04/My-Neighbors-Widow-3-RoseBlue3D-62.jpg",
  "https://reycomix.com/wp-content/uploads/2023/04/My-Neighbors-Widow-3-RoseBlue3D-63.jpg",
  "https://reycomix.com/wp-content/uploads/2023/04/My-Neighbors-Widow-3-RoseBlue3D-64-1-scaled.jpg",
  "https://reycomix.com/wp-content/uploads/2023/04/My-Neighbors-Widow-3-RoseBlue3D-65-1-scaled.jpg",
  "https://reycomix.com/wp-content/uploads/2023/04/My-Neighbors-Widow-3-RoseBlue3D-66-1-scaled.jpg",
  "https://reycomix.com/wp-content/uploads/2023/04/My-Neighbors-Widow-3-RoseBlue3D-67-1-scaled.jpg",
  "https://reycomix.com/wp-content/uploads/2023/04/My-Neighbors-Widow-3-RoseBlue3D-68-1-scaled.jpg",
  "https://reycomix.com/wp-content/uploads/2023/04/My-Neighbors-Widow-3-RoseBlue3D-69-1-scaled.jpg",
  "https://reycomix.com/wp-content/uploads/2023/04/My-Neighbors-Widow-3-RoseBlue3D-70-1-scaled.jpg",
  "https://reycomix.com/wp-content/uploads/2023/04/My-Neighbors-Widow-3-RoseBlue3D-71-1-scaled.jpg",
  "https://reycomix.com/wp-content/uploads/2023/04/My-Neighbors-Widow-3-RoseBlue3D-72-1-scaled.jpg",
  "https://reycomix.com/wp-content/uploads/2023/04/My-Neighbors-Widow-3-RoseBlue3D-73-1-scaled.jpg",
  "https://reycomix.com/wp-content/uploads/2023/04/My-Neighbors-Widow-3-RoseBlue3D-74-1-scaled.jpg",
  "https://reycomix.com/wp-content/uploads/2023/04/My-Neighbors-Widow-3-RoseBlue3D-75-1-scaled.jpg",
  "https://reycomix.com/wp-content/uploads/2023/04/My-Neighbors-Widow-3-RoseBlue3D-76-1-scaled.jpg",
  "https://reycomix.com/wp-content/uploads/2023/04/My-Neighbors-Widow-3-RoseBlue3D-77-1-scaled.jpg",
  "https://reycomix.com/wp-content/uploads/2023/04/My-Neighbors-Widow-3-RoseBlue3D-78-1-scaled.jpg",
  "https://reycomix.com/wp-content/uploads/2023/04/My-Neighbors-Widow-3-RoseBlue3D-79-1-scaled.jpg",
  "https://reycomix.com/wp-content/uploads/2023/04/My-Neighbors-Widow-3-RoseBlue3D-80-1-scaled.jpg",
  "https://reycomix.com/wp-content/uploads/2023/04/My-Neighbors-Widow-3-RoseBlue3D-81-1-scaled.jpg",
  "https://reycomix.com/wp-content/uploads/2023/04/My-Neighbors-Widow-3-RoseBlue3D-82-1-scaled.jpg",
  "https://reycomix.com/wp-content/uploads/2023/04/My-Neighbors-Widow-3-RoseBlue3D-83-1-scaled.jpg",
  "https://reycomix.com/wp-content/uploads/2023/04/My-Neighbors-Widow-3-RoseBlue3D-84-1-scaled.jpg",
  "https://reycomix.com/wp-content/uploads/2023/04/My-Neighbors-Widow-3-RoseBlue3D-85-1-scaled.jpg",
  "https://reycomix.com/wp-content/uploads/2023/04/My-Neighbors-Widow-3-RoseBlue3D-86-1-scaled.jpg",
  "https://reycomix.com/wp-content/uploads/2023/04/My-Neighbors-Widow-3-RoseBlue3D-87-1-scaled.jpg",
  "https://reycomix.com/wp-content/uploads/2023/04/My-Neighbors-Widow-3-RoseBlue3D-88-1-scaled.jpg",
  "https://reycomix.com/wp-content/uploads/2023/04/My-Neighbors-Widow-3-RoseBlue3D-89-1-scaled.jpg",
  "https://reycomix.com/wp-content/uploads/2023/04/My-Neighbors-Widow-3-RoseBlue3D-90-1-scaled.jpg",
  "https://reycomix.com/wp-content/uploads/2023/04/My-Neighbors-Widow-3-RoseBlue3D-91-1-scaled.jpg",
  "https://reycomix.com/wp-content/uploads/2023/04/My-Neighbors-Widow-3-RoseBlue3D-92-1-scaled.jpg",
  "https://reycomix.com/wp-content/uploads/2023/04/My-Neighbors-Widow-3-RoseBlue3D-93-1-scaled.jpg",
  "https://reycomix.com/wp-content/uploads/2023/04/My-Neighbors-Widow-3-RoseBlue3D-94-1-scaled.jpg",
  "https://reycomix.com/wp-content/uploads/2023/04/My-Neighbors-Widow-3-RoseBlue3D-95-1-scaled.jpg",
  "https://reycomix.com/wp-content/uploads/2023/04/My-Neighbors-Widow-3-RoseBlue3D-96-1-scaled.jpg",
  "https://reycomix.com/wp-content/uploads/2023/04/My-Neighbors-Widow-3-RoseBlue3D-97-1-scaled.jpg",
  "https://reycomix.com/wp-content/uploads/2023/04/My-Neighbors-Widow-3-RoseBlue3D-98-1-scaled.jpg",
  "https://reycomix.com/wp-content/uploads/2023/04/My-Neighbors-Widow-3-RoseBlue3D-99-1-scaled.jpg",
  "https://reycomix.com/wp-content/uploads/2023/04/My-Neighbors-Widow-3-RoseBlue3D-100-1-scaled.jpg",
  "https://reycomix.com/wp-content/uploads/2023/04/My-Neighbors-Widow-3-RoseBlue3D-101-1-scaled.jpg",
  "https://reycomix.com/wp-content/uploads/2023/04/My-Neighbors-Widow-3-RoseBlue3D-102-1-scaled.jpg",
  "https://reycomix.com/wp-content/uploads/2023/04/My-Neighbors-Widow-3-RoseBlue3D-103-1-scaled.jpg",
  "https://reycomix.com/wp-content/uploads/2023/04/My-Neighbors-Widow-3-RoseBlue3D-104-1-scaled.jpg",
  "https://reycomix.com/wp-content/uploads/2023/04/My-Neighbors-Widow-3-RoseBlue3D-105-1-scaled.jpg",
  "https://reycomix.com/wp-content/uploads/2023/04/My-Neighbors-Widow-3-RoseBlue3D-106-1-scaled.jpg",
  "https://reycomix.com/wp-content/uploads/2023/04/My-Neighbors-Widow-3-RoseBlue3D-107-1-scaled.jpg",
  "https://reycomix.com/wp-content/uploads/2023/04/My-Neighbors-Widow-3-RoseBlue3D-108-1-scaled.jpg",
  "https://reycomix.com/wp-content/uploads/2023/04/My-Neighbors-Widow-3-RoseBlue3D-109-1-scaled.jpg",
  "https://reycomix.com/wp-content/uploads/2023/04/My-Neighbors-Widow-3-RoseBlue3D-110-1-scaled.jpg",
  "https://reycomix.com/wp-content/uploads/2023/04/My-Neighbors-Widow-3-RoseBlue3D-111-1-scaled.jpg",
  "https://reycomix.com/wp-content/uploads/2023/04/My-Neighbors-Widow-3-RoseBlue3D-112.jpg",
  "https://reycomix.com/wp-content/uploads/2023/04/My-Neighbors-Widow-3-RoseBlue3D-113.jpg",
  "https://reycomix.com/wp-content/uploads/2023/04/My-Neighbors-Widow-3-RoseBlue3D-114.jpg",
  "https://reycomix.com/wp-content/uploads/2023/04/My-Neighbors-Widow-3-RoseBlue3D-115.jpg",
  "https://reycomix.com/wp-content/uploads/2023/04/My-Neighbors-Widow-3-RoseBlue3D-116.jpg",
  "https://reycomix.com/wp-content/uploads/2023/04/My-Neighbors-Widow-3-RoseBlue3D-117.jpg"
]}
      sugeridos={[]}


      info={{
        grupo: "RoseBlue3D",
    tipo: "Comic 3D",
    idioma: "Español",
    serie: "Original",
    personajes: [" "],
etiquetas: ["3D", "Black Widow", "Corrupción", "Creampie", "Gafas", "Garganta Profunda", "Lencería", "Marvel", "MILF", "Parodia", "Pechos Grandes", "RoseBlue3D", "Seducida"],
    artistas: "Rose Blue 3D",
      }}
    />
  );
}

export const infoManga = {
  titulo: "La Viuda De Mi Vecina Capítulo 3 – Rose Blue 3D",
  portada: "https://reycomix.com/wp-content/uploads/2023/04/My-Neighbors-Widow-3-RoseBlue3D-01.jpg",
  reverso: "https://reycomix.com/wp-content/uploads/2023/04/My-Neighbors-Widow-3-RoseBlue3D-28-scaled.jpg",
   fecha:"2026-05-17",


  info: {
        grupo: "RoseBlue3D",
    tipo: "Comic 3D",
    idioma: "Español",
    serie: "Original",
    personajes: [" "],
etiquetas: ["3D", "Black Widow", "Corrupción", "Creampie", "Gafas", "Garganta Profunda", "Lencería", "Marvel", "MILF", "Parodia", "Pechos Grandes", "RoseBlue3D", "Seducida"],
    artistas: "Rose Blue 3D",
  },
};
